<script>
import GlitchText from '@/components/snippets/GlitchText'

const messages = {
  splash: 'AV-1',
  game: 'AV-2',
  cutscene: 'AV-3'
}

export default {
  name: 'CrtOverlayTitle',

  components: {
    GlitchText
  },

  props: {
    message: {
      type: String,
      required: true
    }
  },

  computed: {

    visibleMessage () {
      return messages[this.message]
    }

  }

}
</script>

<template>
  <div class="c-crt-overlay-title">
    <glitch-text :text="visibleMessage" />
  </div>
</template>

<style lang="scss">

.c-crt-overlay-title {
  @include absolute;
  top: 2rem;
  left: 2rem;
  font-size: 4rem;
  background-color: translucent($very-dark, 0.2);
  white-space: nowrap;
}

</style>
